import { useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

dayjs.locale('ko');

export const useCountdown = (initialTime: number, ms = 1000) => {
  const [time, setTime] = useState<number>(initialTime);
  const ref = useRef<NodeJS.Timer | undefined>();

  useEffect(() => {
    ref.current = setInterval(() => {
      const newTime = time - 1000;
      setTime(newTime);
    }, 1000);

    return () => {
      if (ref && ref.current && typeof ref.current === 'number') {
        clearInterval(ref.current);
      }
    };
  }, [time, ms]);

  return time;
};
